module.exports = "<div class=gmw-slide-nav-main__section ng-class=\"{'gmw-slide-nav-main__section--disabled': disabled}\"> <div class=gmw-slide-nav-list-heading> <div class=gmw-slide-nav-list-heading__icon-container ng-transclude=icon> </div> <h3 class=\"heading-h3 h-dark-text\" ng-transclude=title></h3> </div> <div ng-transclude=items></div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/directives/dashboard-menu-nav-section/dashboard-menu-nav-section.html
// module id = 853
// module chunks = 0